module.exports = __webpack_public_path__ + "img/yacht-3.0bb180c9.jpg";